export const Gender = [
  { id: 1, label: "Male" },
  { id: 2, label: "Female" },
  { id: 3, label: "Other" },
];

export const TimePeriods = [
  { id: 1, label: "Year" },
  { id: 2, label: "Quarter" },
  { id: 3, label: "Month" },
  { id: 4, label: "Week" },
  { id: 5, label: "Day" },
  { id: 6, label: "Hour" },
];

export const SaleReportTypes = [
  { id: 1, label: "Sales Summary" },
  { id: 2, label: "User" },
  { id: 3, label: "Location" },
  { id: 4, label: "Register" },
  { id: 5, label: "Customer" },
  { id: 6, label: "Customer Group" },
  { id: 7, label: "Product" },
  { id: 8, label: "SKU Name" },
  { id: 9, label: "Brand" },
  { id: 10, label: "Supplier" },
  { id: 11, label: "Product Category" },
  { id: 12, label: "Tag" },
];

export const SaleMeasureTypes = [
  { id: 1, label: "Avg. items per sale" },
  { id: 2, label: "Avg. sale value" },
  { id: 3, label: "Avg. sale value (incl. tax)" },
  { id: 4, label: "Cost of goods sold" },
  { id: 5, label: "Customer count" },
  { id: 6, label: "Discount count" },
  { id: 7, label: "Discounted" },
  { id: 8, label: "Discounted (%)" },
  { id: 10, label: "Gross profit" },
  { id: 11, label: "Items sold" },
  { id: 13, label: "Margin (%)" },
  { id: 14, label: "Return count" },
  { id: 15, label: "Returns (%)" },
  { id: 16, label: "Revenue" },
  { id: 17, label: "Revenue (incl. tax)" },
  { id: 18, label: "Sale count" },
  { id: 19, label: "Sales with customer attached (%)" },
  { id: 20, label: "Tax" },
];

export const ProdRetType = [
  { id: 1, label: "Sellable" },
  { id: 2, label: "Unsellable" },
];

export const InvCountTypes = [
  {
    id: 1,
    label: "Partial",
    subtitle: "Specify the products to include in this inventory count.",
  },
  {
    id: 2,
    label: "Full Count",
    subtitle: "Include all the products in this inventory count.",
  },
];

export const PrintType = [
  {
    id: 1, label: "Continuous feed", columns: 1, rows: 1,
    labelWidth: "50mm", labelHeight: "30mm", pageMargin: "0mm", gap: "0mm",
    rollWidth: "50mm",
  },
  {
    id: 2, label: "Continuous dual (2x1)", columns: 2, rows: 1,
    labelWidth: "46mm", labelHeight: "30mm", pageMargin: "0mm 2mm", gap: "0mm 4mm",
    rollWidth: "100mm",
  },
  {
    id: 3, label: "A4 Avery sheet of 3X4", columns: 3, rows: 4,
    labelWidth: "63.5mm", labelHeight: "50.8mm", pageMargin: "12mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 4, label: "A4 Avery sheet of 3X5", columns: 3, rows: 5,
    labelWidth: "63.5mm", labelHeight: "42mm", pageMargin: "10mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 5, label: "A4 Avery sheet of 3X6", columns: 3, rows: 6,
    labelWidth: "63.5mm", labelHeight: "35mm", pageMargin: "8mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 6, label: "A4 Avery sheet of 3X7", columns: 3, rows: 7,
    labelWidth: "63.5mm", labelHeight: "30mm", pageMargin: "7mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 7, label: "A4 Avery sheet of 3X8", columns: 3, rows: 8,
    labelWidth: "63.5mm", labelHeight: "26mm", pageMargin: "6mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 8, label: "A4 Avery sheet of 3X9", columns: 3, rows: 9,
    labelWidth: "63.5mm", labelHeight: "23mm", pageMargin: "5mm 5mm", gap: "2mm 3mm",
  },
  {
    id: 9, label: "A4 Avery sheet of 3X10", columns: 3, rows: 10,
    labelWidth: "63.5mm", labelHeight: "20mm", pageMargin: "4mm 5mm", gap: "2mm 3mm",
  },
];

export const ProdType = [
  {
    id: 1,
    label: "Standard Product",
    subtitle: "This product is a single SKU with its own inventory.",
  },
  {
    id: 2,
    label: "Variant Product",
    subtitle:
      "This is a group of similar products with different attributes like size or color. Each variant is a unique SKU with its own inventory.",
  },
  {
    id: 3,
    label: "Composite Product",
    subtitle:
      "This product is made up of specified quantities of one or more products. A composite is a single SKU but uses the inventory of the products within it.",
  },
];

export const SalesType = [
  { id: 1, label: "All Sales" },
  { id: 2, label: "Installment" },
  { id: 3, label: "Installment, Completed" },
  { id: 4, label: "Credit Sale" },
  { id: 5, label: "Credit Sale, Completed" },
  { id: 7, label: "Completed" },
  { id: 8, label: "Voided" },
];

export const AccBalTypes = [
  { id: 1, label: "No" },
  { id: 2, label: "Yes, With no balance limit" },
  { id: 3, label: "Yes, But with a balance limit" },
];

// Legacy types (kept for backward compatibility with existing data)
export const TxnTypes = [
  { id: 1, label: "Cash In" },
  { id: 2, label: "Cash Out" },
  { id: 3, label: "Petty Cash In" },
  { id: 4, label: "Petty Cash Out" },
  { id: 5, label: "Opening Float" },
  { id: 6, label: "Cash Deposit" },
  { id: 7, label: "Cash Withdrawal" },
  { id: 8, label: "Safe Drop" },
  { id: 9, label: "Petty Cash" },
];

// New cash management types (used in the Cash Management form)
export const CashInTypes = [
  { id: 6, label: "Cash Deposit", subtitle: "Add cash from owner/safe to register" },
];

export const CashOutTypes = [
  { id: 7, label: "Cash Withdrawal", subtitle: "Take cash out for an expense" },
  { id: 8, label: "Safe Drop", subtitle: "Drop excess cash to safe (mid-shift)" },
  { id: 9, label: "Petty Cash", subtitle: "Small expense from register" },
];

export const PeriodicType = [
  { id: 1, label: "Today" },
  { id: 2, label: "Yesterday " },
  { id: 3, label: "This Week" },
  { id: 4, label: "Last Week" },
  { id: 5, label: "This Month" },
  { id: 6, label: "Last Month" },
  { id: 7, label: "This Year" },
  { id: 8, label: "Last Year" },
];

export const Role = [
  { id: 1, label: "Admin" },
  { id: 2, label: "Manager" },
  { id: 3, label: "Cashier" },
];

export const SkuTypes = [
  { id: 1, label: "Auto-Generated" },
  { id: 2, label: "Custom" },
  { id: 3, label: "EAN" },
  { id: 4, label: "ISBN" },
  { id: 5, label: "ITF" },
  { id: 6, label: "JAN" },
  { id: 7, label: "UPC" },
];

export const Status = [
  { id: 1, label: "Active" },
  { id: 2, label: "Inactive" },
];

export const PayMethod = [
  { id: 1, label: "Cash" },
  { id: 2, label: "Cheque" },
  { id: 3, label: "Card Payment" },
  { id: 4, label: "Online Payment" },
];

export const Healths = [
  { id: 1, label: "Blood Pressure" },
  { id: 2, label: "Diabites" },
  { id: 3, label: "Back Pain" },
  { id: 4, label: "Cholestrol" },
  { id: 5, label: "Thyroid" },
  { id: 6, label: "Knee Pain" },
];

export const MemberStatus = [
  { id: 1, label: "Respectful" },
  { id: 2, label: "Cleanliness" },
  { id: 3, label: "Empathy" },
  { id: 4, label: "Thoughtfulness" },
  { id: 5, label: "Responsiveness" },
  { id: 6, label: "Mindfulness" },
  { id: 7, label: "Quietness" },
  { id: 8, label: "Generosity" },
  { id: 9, label: "Boundaries" },
  { id: 10, label: "Honesty" },
  { id: 11, label: "Patience" },
  { id: 12, label: "Supportive" },
  { id: 13, label: "Maintaining hygiene" },
  { id: 14, label: "Other" },
];

export const PaymentMethods = [
  { id: 1, label: "Cash" },
  { id: 2, label: "Cheque" },
  { id: 3, label: "Internet Banking" },
  { id: 4, label: "Debit Card" },
  { id: 5, label: "Credit Card" },
  { id: 6, label: "Google Pay" },
  { id: 7, label: "Other" },
];

export const ReceiptType = [
  { id: 1, label: "Thermal Printer" },
  { id: 2, label: "Normal Printer (A4)" },
  { id: 3, label: "Normal Printer (A5)" },
];

export const PosTemplate = [
  { id: 1, label: "Version 1" },
  { id: 2, label: "Version 2" },
];

export const PriceTypes = [
  { id: 1, label: "Flat Price" },
  { id: 2, label: "Dynamic Price" },
  // Renamed from "Open to Sell" 2026-07-28. The enum stays PriceType.OpenToSell
  // (id 3) — this is a label change only, nothing about the behaviour moved.
  { id: 3, label: "No Rule" },
];

export const ReturnReason = [
  { id: 1, label: "Mind Change" },
  { id: 2, label: "Date Expire" },
  { id: 3, label: "Bad Item" },
  { id: 4, label: "Damage" },
  { id: 5, label: "Extra" },
  { id: 6, label: "No Sale" },
  { id: 7, label: "Others" },
];
